(() => {
  'use strict';
  const views = JSON.parse(document.getElementById('product-gallery-data').textContent);
  const stage = document.getElementById('enlarge');
  const mainImage = document.getElementById('main-art');
  const modal = document.getElementById('lightbox');
  const lightImage = document.getElementById('lightbox-image');
  const zoom = document.getElementById('zoom-image');
  let selected = 'full';
  function selectView(key) {
    const view = views[key];
    selected = key;
    mainImage.src = view.src;
    mainImage.alt = view.alt;
    stage.classList.toggle('closeup',key==='detail');
    stage.setAttribute('aria-label',`Enlarge ${view.caption}`);
    document.getElementById('view-caption').textContent=view.caption;
    document.querySelectorAll('[data-view]').forEach(button => {
      const active=button.dataset.view===key;
      button.classList.toggle('active',active);
      button.setAttribute('aria-pressed',String(active));
    });
  }
  function openView(key) {
    const view=views[key];
    lightImage.src=view.src;
    lightImage.alt=view.alt;
    document.getElementById('lightbox-caption').textContent=view.caption;
    modal.classList.remove('zoomed');
    modal.classList.toggle('detail-modal',key==='detail');
    zoom.setAttribute('aria-pressed','false');
    zoom.textContent='Zoom in';
    modal.showModal();
  }
  document.querySelectorAll('[data-view]').forEach(button=>button.addEventListener('click',()=>selectView(button.dataset.view)));
  stage.addEventListener('click',()=>openView(selected));
  document.getElementById('view-certificate').addEventListener('click',event=>{event.preventDefault();openView('certificate');});
  zoom.addEventListener('click',()=>{
    const active=modal.classList.toggle('zoomed');
    zoom.setAttribute('aria-pressed',String(active));
    zoom.textContent=active?'Fit to screen':'Zoom in';
  });
  document.getElementById('close').addEventListener('click',()=>modal.close());
  modal.addEventListener('click',event=>{if(event.target===modal)modal.close();});
  document.querySelectorAll('[name="id"][data-price]').forEach(input=>input.addEventListener('change',()=>{
    document.getElementById('price').textContent=input.dataset.price;
    const button=document.getElementById('add');button.disabled=input.dataset.available!=='true';button.textContent=button.disabled?'Sold out':'Add to cart';
    const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url);
  }));
})();
